import { Button, Checkbox } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { black, settingsButtonBackgroundColor, white } from 'styles/Colors';

export const TopBarWrapper = styled.div`
  padding: 18.5px 16px 0;
  width: 100%;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  background: ${white};
  font-family: Lato;
  color: ${black};
  z-index: 15;
  position: relative;
`;

export const SettingsBtn = styled.div`
  background-color: ${settingsButtonBackgroundColor};
  border-radius: 4px;
  display: flex;
  height: 32px;
  width: 32px;
  align-items: center;
  justify-content: center;
  position: relative;

  cursor: pointer;
`;

export const FirstRow = styled.div`
  display: flex;
  margin-bottom: 13px;
  justify-content: space-between;
`;

export const SecondRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TopBarData = styled.div`
  display: flex;
  gap: 14px;
`;

export const Title = styled.div`
  font-size: 15px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 0.5px;
`;

export const Verify = styled.div`
  display: flex;
  margin-right: 55px;
`;

export const Label = styled.div`
  margin-right: 13px;
  bottom: 2px;
  position: relative;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const StyledCheckbox = styled((props) => <Checkbox {...props} />)`
  &&& {
    border: none;
    height: auto;
    padding: 0 8px;
    .MuiFormControlLabel-label {
      font-size: 13px;
    }

    .MuiCheckbox-root {
      width: 15px;
    }
  }
`;

export const SendWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
`;

export const Divider = styled.div`
  border-left: 1px solid #e0e0e0;
  width: 1px;
  height: 24px;
`;

export const SubmitControls = styled.div`
  display: flex;
  gap: 8px;
`;

export const UmpirePlaceholderInfo = styled.div`
  color: #ee1b34;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 15.4px;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 32px;
    padding: 0;
    background-color: transparent;
    span {
      margin-right: 0;
      margin-left: 0;
    }
  }
`;

export const TeamsWrapper = styled.div`
  display: flex;
  gap: 14px;
`;

export const SubmitWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
